import { Component } from '@angular/core';

import { AnalyticsService } from '@ridango/core/lib/services/analytics.service';

@Component({
    selector: 'gl-schedule-planner-page',
    templateUrl: './schedule-planner-page.component.html'
})
export class SchedulePlannerPageComponent {
    constructor(private analyticsService: AnalyticsService) {}

    handleSearch() {
        this.analyticsService.eventTrack('search', {
            search_term: 'schedule-planner'
        });
    }
}
